import React from "react";
import PropTypes from "prop-types";
import TabNav from "../common/TabNav";
import TabNavItem from "../common/TabNavItem";
import { GetTopNavItemsForScope } from "./NavItemHelper";

const TopNav = ({ topNavTabSettings, scope, disableTopNav }) => {
	const items = GetTopNavItemsForScope(topNavTabSettings, scope);

	return (
		<nav>
			<TabNav>
				{items.map((item, i) => (<TabNavItem key={i} text={item.text} iconType={item.iconType} color={item.color}
					to={item.to} disabled={item.disabled || disableTopNav} visible={item.visible} />))}
			</TabNav>
		</nav>
	);
};

TopNav.propTypes = {
	topNavTabSettings: PropTypes.object.isRequired,
	scope: PropTypes.string,
	disableTopNav: PropTypes.bool
};

export default TopNav;
